import {Box} from "@mui/material";
import {alpha, Theme, ThemeProvider, useTheme} from "@mui/material/styles";
import React, {useMemo} from "react";

interface Props {
    /** What the text stands on: the page colour, or the surface of a card or the Plain sheet. */
    on: 'page' | 'surface'
    children: React.ReactNode
}

/*
    The theme's text colours are the surface's. Whatever stands on the page (footer, screens, headings outside a
    card) switches to the page's set here, and a card switches back. Layout-neutral (`display: contents`), so a
    parent Stack keeps spacing the children. Outside the runner's theme it changes nothing.
 */
function SurveyTextOn({on, children}: Props) {
    const outer = useTheme();
    const colors = outer.surveyText?.[on];

    const theme = useMemo<Theme | undefined>(() => colors && {
        ...outer,
        palette: {
            ...outer.palette,
            text: {...outer.palette.text, primary: colors.primary, secondary: colors.secondary},
            divider: alpha(colors.primary, 0.16),
        },
    }, [outer, colors]);

    if (!theme || !colors) return <>{children}</>;

    return (
        <ThemeProvider theme={theme}>
            {/* Links too: the baseline's accent has to read on both backgrounds at once, and on a dark page with
                light cards that leaves black. */}
            <Box sx={{display: 'contents', color: 'text.primary', '& a': {color: colors.link}}}>{children}</Box>
        </ThemeProvider>
    );
}

export default SurveyTextOn;
